import { Suspense } from 'react'
import styled from 'styled-components'

import { Separator } from '@blade/ui-kit'
import { PairPopoverByAddress } from '@root/features/pair'
import { useTranslation } from '@root/shared/localization'

import { DevToken } from './explore-dev-token'

import type { PairDevTokensInfo } from '@root/entities/pair/hooks/use-pair-dev-tokens-info'

interface Props {
  devTokensInfo: PairDevTokensInfo
}

const TopTokens = [0, 1, 2] as const

export function ExploreDevTokensTooltipClickArea({ devTokensInfo }: Props) {
  const { t } = useTranslation()

  const { topTokensWithoutCurrent } = devTokensInfo

  if (topTokensWithoutCurrent.length === 0) {
    return undefined
  }

  return (
    <>
      <Sep variant="solid" color="var(--backgroundA-3)" />
      <SubTitle>{t('explore.developer-tokens-tooltip.top-tokens')}</SubTitle>
      <Footer>
        {TopTokens.map((place) => {
          const devToken = topTokensWithoutCurrent[place]
          if (!devToken || !devToken.pairAddress) {
            return undefined
          }

          return (
            <Suspense
              key={place}
              fallback={<DevToken place={place} devToken={devToken} />}
            >
              <PairPopoverByAddress
                pairAddress={devToken.pairAddress}
                network={devToken.currencyModel.network}
              >
                <DevToken place={place} devToken={devToken} />
              </PairPopoverByAddress>
            </Suspense>
          )
        })}
      </Footer>
    </>
  )
}

const Sep = styled(Separator)`
  margin: 10px 0 8px;
`

const SubTitle = styled.div`
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 5px;
`
const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-inline: -10px;
  margin-bottom: -10px;
`
